// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConnectionStatusMessage, ConnectionStatusMessageT } from './connection-status-message';
import { EarthquakeProtectionMessage, EarthquakeProtectionMessageT } from './earthquake-protection-message';
import { EarthquakeStatusMessage, EarthquakeStatusMessageT } from './earthquake-status-message';
import { EscalatorStatusContent, unionToEscalatorStatusContent, unionListToEscalatorStatusContent } from './escalator-status-content';
import { GeneralStatusMessage, GeneralStatusMessageT } from './general-status-message';
import { LoadWeigherStatusMessage, LoadWeigherStatusMessageT } from './load-weigher-status-message';
import { ModeStatusMessage, ModeStatusMessageT } from './mode-status-message';
import { TrafficStatusMessage, TrafficStatusMessageT } from './traffic-status-message';


export class EscalatorStatusMessage implements flatbuffers.IUnpackableObject<EscalatorStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorStatusMessage):EscalatorStatusMessage {
  return (obj || new EscalatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorStatusMessage):EscalatorStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

statusType():EscalatorStatusContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EscalatorStatusContent.NONE;
}

status<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startEscalatorStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addStatusType(builder:flatbuffers.Builder, statusType:EscalatorStatusContent) {
  builder.addFieldInt8(0, statusType, EscalatorStatusContent.NONE);
}

static addStatus(builder:flatbuffers.Builder, statusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, statusOffset, 0);
}

static endEscalatorStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // status
  return offset;
}

static createEscalatorStatusMessage(builder:flatbuffers.Builder, statusType:EscalatorStatusContent, statusOffset:flatbuffers.Offset):flatbuffers.Offset {
  EscalatorStatusMessage.startEscalatorStatusMessage(builder);
  EscalatorStatusMessage.addStatusType(builder, statusType);
  EscalatorStatusMessage.addStatus(builder, statusOffset);
  return EscalatorStatusMessage.endEscalatorStatusMessage(builder);
}

unpack(): EscalatorStatusMessageT {
  return new EscalatorStatusMessageT(
    this.statusType(),
    (() => {
      const temp = unionToEscalatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: EscalatorStatusMessageT): void {
  _o.statusType = this.statusType();
  _o.status = (() => {
      const temp = unionToEscalatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class EscalatorStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public statusType: EscalatorStatusContent = EscalatorStatusContent.NONE,
  public status: ConnectionStatusMessageT|EarthquakeProtectionMessageT|EarthquakeStatusMessageT|GeneralStatusMessageT|LoadWeigherStatusMessageT|ModeStatusMessageT|TrafficStatusMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const status = builder.createObjectOffset(this.status);

  return EscalatorStatusMessage.createEscalatorStatusMessage(builder,
    this.statusType,
    status
  );
}
}
